import React from "react";
import { classNames } from "./classNames";

type BackgroundComponentProps = React.HTMLAttributes<HTMLDivElement>;

type BackgroundComponentOptions = {
  backgroundImage: string;
  baseClassName?: string;
  displayName?: string;
  useImageElement?: boolean;
  imageAlt?: string;
  imageClassName?: string;
};

export const createBackgroundComponent = ({
  backgroundImage,
  baseClassName = "",
  displayName,
  useImageElement = false,
  imageAlt = "",
  imageClassName,
}: BackgroundComponentOptions) => {
  const Background = React.forwardRef<HTMLDivElement, BackgroundComponentProps>(
    ({ className, style, children, ...rest }, ref) => {
      if (useImageElement) {
        return (
          <div
            ref={ref}
            className={classNames(baseClassName, className)}
            style={style}
            {...rest}
          >
            <img
              src={backgroundImage}
              alt={imageAlt}
              className={classNames(
                "absolute inset-0 -z-10 h-full w-full select-none object-cover pointer-events-none",
                imageClassName
              )}
            />
            {children}
          </div>
        );
      }

      return (
        <div
          ref={ref}
          className={classNames(baseClassName, className)}
          style={{ backgroundImage: `url(${backgroundImage})`, ...style }}
          {...rest}
        >
          {children}
        </div>
      );
    }
  );

  Background.displayName = displayName ?? "SportBackground";

  return Background;
};
